import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ValidacaoPrescriptionPendenteItem } from '../../_models/prescription-validacao-pendentes-item.model';
import {
  Component,
  ElementRef,
  EventEmitter, 
  HostListener,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  QueryList,
  ViewChildren,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { map, Observable, startWith } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { GlobalService, LoggerService, JsonService } from '../../_services';
import { Router } from '@angular/router';
import { ProductConteudoRetornoApi } from '../../_models/product-conteudo-retorno-api.model';
import { ProductApiResponse } from '../../_models/product_retorno_maestro.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-form-pending',
  templateUrl: './product-form-pending.component.html',
  styleUrls: ['./product-form-pending.component.scss', '../../detalhe/detalhe.component.scss']
})
export class ProductFormPendingComponent implements OnInit, OnChanges, AfterViewInit {
  public imagemDocumentoUrl: string = '';

  @Input() produtoForm!: FormArray;
  @Input() prescriptionItem?: ValidacaoPrescriptionPendenteItem;
  @Input() doShortcutActive = true;
  @Input() codigoPaisMaestro: string = '';
  @Input() mostrarPendencias: boolean = false;

  @Output() validarEntrada = new EventEmitter<void>();
  @Output() isValidatedChange = new EventEmitter<boolean>();

  @ViewChildren('produtoInput') produtoInputs!: QueryList<ElementRef>;
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
  @ViewChildren('confirmarButtonManual') confirmarButtonManual!: ElementRef;
  @ViewChild('pesquisaInput') pesquisaInput!: ElementRef;
  @ViewChildren('produtoNome') produtoNomes!: QueryList<ElementRef>;
  @ViewChildren('retornoProduto') retornoProdutos!: QueryList<ElementRef>;
  @ViewChild('productList') productListRef!: ElementRef;

  private addProdutoNextBlocked = false;

  public produtoFiltrado: string[] = [];
  public posologiaFiltrado: string[] = [];

  public filteredProdutos$: Observable<string[]>[] = [];
  public filteredPosologia$: Observable<string[]>[] = [];

  isModalProdutoOpen: boolean = false;
  pesquisaProduto: string = '';
  produtoSelecionadoNome: string = '';
  produtoSelecionadoCombobox: string = '';
  listaProdutosFiltrada: any[] = [];
  listaProdutosCompleta: any[] = [];
  indexProdutoAtual: number = -1;
  public produtosValidados: boolean[] = [];
  private focusComboOnLoad: boolean = false;
  private isBuscandoProdutos: boolean = false;
  private ultimoTermoBuscaProdutoApi: string = '';
  private termoBuscaProdutoPendente: string = '';

  isModalRemoverOpen: boolean = false;
  indexProdutoRemover: number = -1;
  motivoRemocaoSelecionado: string = '';
  produtoRemoverNome: string = '';
  
  isModalConfirmarExclusaoManualOpen: boolean = false;
  indexProdutoManualRemover: number = -1;
  motivosRemocao: string[] = [
    '000 - MEDICACIÓN REPETIDA',
    '035 - NO LEGIBLE (caligrafía)',
    '083 - NO MEDICAMENTO',
    '084 - SEM FF',
    '085 - MAGISTRALES',
    '120 - ACCESORIOS',
    '130 - OTROS NO DETERMINADOS'
  ];

  constructor(
    private fb: FormBuilder,
    private globalService: GlobalService,
    private logger: LoggerService,
    private jsonService: JsonService,
    private elementRef: ElementRef,
    private router: Router,
    private translate: TranslateService
  ) {}

  get produtos(): FormArray {
    return this.produtoForm;
  }

  ngOnInit(): void {
    const { produtosContent } = this.extractPrescriptionData();

    if (this.produtos.length === 0) {
      if (produtosContent.length > 0) {
        produtosContent.forEach(p => {
          this.produtos.push(this.createProduto(p));
          this.produtosValidados.push(false);
        });
      } else {
        this.produtos.push(this.createProduto());
        this.produtosValidados.push(false);
      }
    } else if (this.prescriptionItem) {
      
      var index = 0;
      this.produtos.controls.forEach((control) => {
        if (this.produtosValidados.length <= index) this.produtosValidados.push(false);
        const productGroup = control as FormGroup;

        if (productGroup.get('nome')?.value && produtosContent.length > 0) {
          const primeiroProduto = produtosContent[index];
          const retornoApi = primeiroProduto?.retorno_api ?? {
            conteudoProd: [],
            validProd: false,
            conteudoProdFiltro: []
          };

          productGroup.patchValue(
            {
              nome: primeiroProduto.nome,
              posologia: primeiroProduto.posologia ?? '',
              motivo_exclusao_produto: primeiroProduto.motivo_exclusao_produto ?? '',
              retorno_api: retornoApi,
              retorno_produto: this.formatRetornoProduto(retornoApi?.conteudoProd?.[0]), // Mantém a seleção inicial do primeiro produto
              ConteudoProdFiltro: (retornoApi.conteudoProd || []).map(p => this.formatRetornoProduto(p)) // Popula com todos os produtos formatados
            },
            { emitEvent: false }
          );
        }

        index++;
      });
    }

    this.setupProdutoFilters();
    setTimeout(() => this.atualizarValidacao(), 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let needUpdate = false;
    if (changes['produtoForm'] && !changes['produtoForm'].firstChange) {
      if (this.produtos) {
        this.produtosValidados = this.produtos.controls.map(() => false);
        this.setupProdutoFilters();
        needUpdate = true;
      }
    } else if (changes['prescriptionItem'] && !changes['prescriptionItem'].firstChange) {
      if (this.produtos) {
        this.produtosValidados = this.produtos.controls.map(() => false);
        needUpdate = true;
      }
    }
    if (needUpdate) {
      setTimeout(() => {
        this.atualizarValidacao();
        this.ajustarAlturaScroll();
      }, 0);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.ajustarAlturaScroll(), 300);
  }

  @HostListener('window:resize')
  public ajustarAlturaScroll(): void {
    const scrollContainer = this.elementRef.nativeElement.querySelector('.product_data__items_scroll') as HTMLElement;
    if (scrollContainer) {
      const rect = scrollContainer.getBoundingClientRect();
      // Calcula a altura restante da tela subtraindo a posição do topo e uma margem inferior para os botões (~90px)
      const alturaDisponivel = window.innerHeight - rect.top - 90; 
      const alturaFinal = Math.max(250, alturaDisponivel); // Mantém um limite mínimo de 250px para usabilidade
      scrollContainer.style.maxHeight = `${alturaFinal}px`;
      scrollContainer.style.overflowY = 'auto';
    }
  }

  private extractPrescriptionData(): { produtosContent: ProductApiResponse[] } {
    const item = this.prescriptionItem;
    let conteudo: any = {};

    if (item?.conteudo) {
      try {
        conteudo = JSON.parse(item.conteudo);
      } catch (e) {
        this.logger.error('Erro ao processar conteúdo da prescrição', e);
      }
    }

    return {
      produtosContent: (conteudo?.produto || []) as ProductApiResponse[]
    };
  }

  private createProduto(product?: any, isManual: boolean = false): FormGroup {
    const nome = product?.nome || '';
    const posologia = product?.posologia || '';
    const motivo_exclusao_produto = product?.motivo_exclusao_produto || '';
    const interaccion_del_usuario = product?.interaccion_del_usuario || (isManual ? 'Item informado pelo usuário' : '');
    const nome_produto_original = product?.nome_produto_original || nome;
    const nome_produto_salvo = product?.nome_produto_salvo || '';
    const nro_presen = product?.nro_presen || '';
    const retorno_api = product?.retorno_api || {
      conteudoProd: [],
      validProd: false,
      conteudoProdFiltro: []
    };

    const ConteudoProdFiltro = (retorno_api.conteudoProd || []).map(p => this.formatRetornoProduto(p));
    const raizMaestro = this.formatRetornoProduto(retorno_api?.conteudoProd?.[0]);

    return this.fb.group({
      nome: [nome],
      posologia: [posologia],
      motivo_exclusao_produto: [motivo_exclusao_produto],
      retorno_api: [retorno_api],
      retorno_produto: [raizMaestro],
      ConteudoProdFiltro: [ConteudoProdFiltro],
      is_manual: [isManual],
      interaccion_del_usuario: [interaccion_del_usuario],
      nome_produto_original: [nome_produto_original],
      nome_produto_salvo: [nome_produto_salvo],
      nro_presen: [nro_presen]
    });
  }

  addProdutoFirst(): void {
    if (this.addProdutoNextBlocked) return;

    this.addProdutoNextBlocked = true;

    const newProduct = this.createProduto(undefined, true);

    this.produtos.insert(0, newProduct);
    this.produtosValidados.unshift(false);
    this.setupProdutoFilters();
    this.atualizarValidacao();

    setTimeout(() => {
      this.addProdutoNextBlocked = false;
    }, 300);
  }

  addProdutoBelow(index: number): void {
    const insertIndex = index + 1;
    this.produtos.insert(insertIndex, this.createProduto(undefined, true));
    this.produtosValidados.splice(insertIndex, 0, false);
    this.setupProdutoFilters();
    this.atualizarValidacao();

    setTimeout(() => {
      this.produtoInputs?.toArray()[insertIndex]?.nativeElement?.focus();
    }, 100);
  }
  private itemValidado(index: number): boolean {
    const validado = this.produtosValidados[index];
    if (this.isProdutoRemovido(index) || this.isValid(index)) {
      return true;
    }

    const group = this.produtos.at(index);
    const isManual = group.get('is_manual')?.value;
    const retornoProd = group.get('retorno_produto')?.value;
    const nomeProd = group.get('nome')?.value;

    const retornoInformado = typeof retornoProd === 'string' ? retornoProd.trim() !== '' : !!retornoProd;
    const nomeInformado = typeof nomeProd === 'string' ? nomeProd.trim() !== '' : !!nomeProd;

    // Item manual tem dois campos onde o nome pode ser digitado (nome, no topo, e
    // retorno_produto, no bloco de status com a busca) — aceita qualquer um dos dois.
    const isInformado = isManual ? (nomeInformado || retornoInformado) : retornoInformado;

    return validado === true || isInformado;
  }

  // Usado no template para destacar o campo de retorno quando o revisor tenta salvar
  // sem confirmar este item (ver mostrarPendencias, disparado pelo componente pai).
  campoIncompleto(index: number): boolean {
    return this.mostrarPendencias && !this.itemValidado(index);
  }

  atualizarValidacao() {
    const todosValidados = this.produtosValidados.every((_, index) => this.itemValidado(index));
    this.isValidatedChange.emit(todosValidados);
  }

  setInteraction(index: number, interaction: string): void {
    const control = this.produtos.at(index);
    if (control && control.get('interaccion_del_usuario')?.value !== interaction) {
      control.get('interaccion_del_usuario')?.setValue(interaction, { emitEvent: false });
    }
  }

  onNomeInput(index: number): void {
    // nome só é editável (readonly=false) quando isProdutoManual — é a única forma de
    // digitar nele; nos demais status o campo reflete a leitura da IA e fica bloqueado.
    if (this.isProdutoManual(index)) {
      this.setInteraction(index, 'Item informado pelo usuário');
      this.atualizarValidacao();
    }
  }

  onRetornoProdutoInput(index: number): void {
    this.setInteraction(index, 'Item informado pelo usuário');
    this.produtos.at(index).get('nro_presen')?.setValue('');
    this.atualizarValidacao();
  }

  onAmbiguousChange(index: number): void {
    this.setInteraction(index, 'Item selecionado da ambiguidade');
    const retornoProduto = this.produtos.at(index).get('retorno_produto')?.value || '';
    this.produtos.at(index).get('nro_presen')?.setValue(this.getNroPresenByNome(index, retornoProduto));
    this.atualizarValidacao();
  }

  onProdutoNaoEncontradoChange(index: number, event: any): void {
    if (event.target?.checked) {
      this.setInteraction(index, 'marcado checkbox não encontrado.');
    }
    this.atualizarValidacao();
  }

  removeProduto(index: number): void {
    if (this.produtos.length < 2) return;

    // Se for um produto manual, exclui direto do array mediante confirmação
    if (this.isProdutoManual(index)) {
      this.indexProdutoManualRemover = index;
      this.isModalConfirmarExclusaoManualOpen = true;
      setTimeout(() => this.confirmarButtonManual?.nativeElement?.focus(), 0);
      return;
    }

    this.indexProdutoRemover = index;
    this.produtoRemoverNome = this.produtos.at(index).get('nome')?.value || '';
    this.motivoRemocaoSelecionado = this.produtos.at(index).get('motivo_exclusao_produto')?.value || '';
    this.isModalRemoverOpen = true;
  }

  clearProdutos(): void {
    this.produtos.clear();
    this.produtos.push(this.createProduto(undefined, true));
    this.produtosValidados = [false];
    this.setupProdutoFilters();
    this.atualizarValidacao();

    setTimeout(() => {
      this.produtoInputs?.toArray()[0]?.nativeElement?.focus();
    }, 300);
  }

  verificarAtalho(event: KeyboardEvent, campo: string): void {
    const campoToNumber = parseInt(campo, 10);

    if (event.altKey && (event.key === 'q' || event.key === 'Q')) {
      if (this.produtos.length > 1) {
        this.removeProduto(campoToNumber);
      }
    }

    if (event.altKey && (event.key === 'w' || event.key === 'W')) {
      this.addProdutoBelow(campoToNumber);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleDocumentKeydown(event: KeyboardEvent): void {
    if (this.isModalProdutoOpen && event.altKey) {
      let numStr: string | null = null;

      // Captura o código da tecla física (Digit0-9 ou Numpad0-9), resolvendo o bug em teclados internacionais e Mac
      const codeMatch = event.code ? /^(Digit|Numpad)([0-9])$/.exec(event.code) : null;
      if (codeMatch) {
        numStr = codeMatch[2];
      } else if (/^[0-9]$/.test(event.key)) {
        numStr = event.key; // Fallback caso event.code não esteja presente
      }

      if (numStr !== null) {
        event.preventDefault();
        event.stopPropagation();
        const num = parseInt(numStr, 10);
        const index = num; // Mapeia exatamente 0-9 para os índices 0-9 da lista
        if (this.listaProdutosFiltrada && this.listaProdutosFiltrada[index]) {
          this.produtoSelecionadoCombobox = index.toString();
          this.confirmarSelecaoCombo(event);
        }
      }
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!event.altKey) return;
    if (!this.doShortcutActive) return;

    event.preventDefault();

    switch (event.key) {
      case 'F':
      case 'f':
        this.clearProdutos();
        break;
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleShiftP(event: KeyboardEvent): void {
    if (event.shiftKey && (event.key === 'p' || event.key === 'P')) {
      if (event.ctrlKey) {
        event.preventDefault();
        this.addProdutoFirst();
      } else {
        event.preventDefault();
        for (let i = 0; i < this.produtos.length; i++) {
          if (!this.isValid(i) && !this.isProdutoRemovido(i)) {
            const el = this.retornoProdutos?.find(r => r.nativeElement.id === `retorno_produto_${i}`);
            if (el) {
              el.nativeElement.focus();
              return;
            }
          }
        }
      }
    }
  }

  // Exponha este método para o componente Pai chamá-lo
  public focusFirstProductStatus(): void {
    if (this.retornoProdutos && this.retornoProdutos.first) {
      this.retornoProdutos.first.nativeElement.focus();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    if (this.isModalRemoverOpen) {
      this.fecharModalRemover();
    }
    if (this.isModalConfirmarExclusaoManualOpen) {
      this.fecharModalConfirmarExclusaoManual();
    }
  }

  isProdutoFieldDirty(index: number, field: string): boolean {
    const group = this.produtos.at(index) as FormGroup;
    return group.get(field)?.dirty ?? false;
  }

  isProdutoValido(index: number): boolean {
    return this.produtos.at(index).valid;
  }

  getProductStatus(index: number): string {
    const group = this.produtos.at(index) as FormGroup;
    if (group.get('is_manual')?.value) {
      return 'Adicionado manualmente';
    }

    const retornoApi = group.get('retorno_api')?.value;
    const validProd = retornoApi?.validProd;
    const conteudoCount = retornoApi?.conteudoProd?.length || 0;

    if (!validProd && conteudoCount > 1) {
      return 'Ambíguo';
    }

    if (validProd && conteudoCount === 1) {
      return 'Válido';
    }

    if (!validProd && conteudoCount === 0) {
      return 'Não encontrado';
    }

    return '';
  }

  getStatusClass(index: number): string {
    const status = this.getProductStatus(index);

    switch (status) {
      case 'Ambíguo':
        return 'ambiguous';
      case 'Válido':
        return 'valid';
      case 'Adicionado manualmente':
        return 'valid';
      case 'Não encontrado':
        return 'not-found';
      default:
        return '';
    }
  }

  isAmbiguous(index: number): boolean {
    return this.getProductStatus(index) === 'Ambíguo';
  }

  isValid(index: number): boolean {
    return this.getProductStatus(index) === 'Válido';
  }

  isNotFound(index: number): boolean {
    return this.getProductStatus(index) === 'Não encontrado';
  }

  private getNroPresenByNome(index: number, nome: string): string {
    const retornoApi = this.produtos.at(index).get('retorno_api')?.value;
    const conteudoProd: ProductConteudoRetornoApi[] = retornoApi?.conteudoProd || [];
    const matched = conteudoProd.find(p => this.formatRetornoProduto(p) === nome);
    return matched?.NRO_PRESEN || '';
  }

  private formatRetornoProduto(prod?: ProductConteudoRetornoApi): string {
    if (!prod) return '';

    const campos = [
      prod.RAIZ_MAESTRO,
      prod.DESC_EXTENDIDA_MAESTRO,
      prod.CONCENTRACION_MAESTRO,
      prod.FORMAF_MAESTRO,
    ];

    return campos.filter(Boolean).join(' ').replace(/'/g, '') || '';
  }

  private setupProdutoFilters(): void {
    this.filteredProdutos$ = [];
    this.filteredPosologia$ = [];

    this.produtos.controls.forEach((control: AbstractControl, index: number) => {
      const group = control as FormGroup;
      const nomeControl = group.get('nome');
      const posologiaControl = group.get('posologia');

      if (nomeControl) {
        this.filteredProdutos$[index] = nomeControl.valueChanges.pipe(
          startWith(nomeControl.value || ''),
          map((val: string) => this.filterListaProdutos(val))
        );
      }

      if (posologiaControl) {
        this.filteredPosologia$[index] = posologiaControl.valueChanges.pipe(
          startWith(posologiaControl.value || ''),
          map((val: string) => this.filterListaPosologia(val))
        );
      }
    });
  }

  private filterListaProdutos(val: string): string[] {
    const filterValue = (val || '').toUpperCase();

    return this.globalService.listaProdutos.filter(produto =>
      produto.toUpperCase().includes(filterValue)
    );
  }

  private filterListaPosologia(val: string): string[] {
    const filterValue = (val || '').toUpperCase();

    return this.globalService.listaPosologia.filter(posologia =>
      posologia.toUpperCase().includes(filterValue)
    );
  }

  abrirModalProduto(index: number, usarRetornoComoPesquisa: boolean = false): void {
    this.indexProdutoAtual = index;
    this.isModalProdutoOpen = true;
    const retornoProduto = this.produtos.at(index).get('retorno_produto')?.value || '';
    this.pesquisaProduto = usarRetornoComoPesquisa ? retornoProduto : ''; 
    this.produtoSelecionadoCombobox = '';
    
    this.produtoSelecionadoNome = this.produtos.at(index).get('nome')?.value || '';
    this.focusComboOnLoad = false;
    this.listaProdutosCompleta = [];
    this.isBuscandoProdutos = false;
    this.ultimoTermoBuscaProdutoApi = '';
    this.termoBuscaProdutoPendente = '';
    this.filtrarProdutos(true);

    setTimeout(() => {
      if (this.pesquisaInput) {
        this.pesquisaInput.nativeElement.focus();
      }
    }, 100);
  }

  abrirModalProdutoSpace(event: Event, index: number): void {
    const kbEvent = event as KeyboardEvent;
    if (kbEvent.shiftKey) {
      event.preventDefault();
      this.abrirModalProduto(index, true);
    }
  }

  abrirModalProdutoEnter(event: Event, index: number, usarRetornoComoPesquisa: boolean = false): void {
    event.preventDefault();
    this.abrirModalProduto(index, usarRetornoComoPesquisa);
  }

  fecharModalProduto(focusNextPendingProduct: boolean = false): void {
    this.isModalProdutoOpen = false;
    this.pesquisaProduto = '';
    this.produtoSelecionadoCombobox = '';
    this.listaProdutosFiltrada = [];
    this.listaProdutosCompleta = [];
    this.isBuscandoProdutos = false;
    this.ultimoTermoBuscaProdutoApi = '';
    this.termoBuscaProdutoPendente = '';
    
    if (this.indexProdutoAtual >= 0) {
      const idx = this.indexProdutoAtual;
      setTimeout(() => {
        if (!focusNextPendingProduct || !this.focusNextPendingProduct(idx)) {
          const element = document.getElementById(`retorno_produto_${idx}`);
          if (element) {
            element.focus();
          }
        }
      }, 100);
    }
  }

  private focusNextPendingProduct(currentIndex: number): boolean {
    for (let index = currentIndex + 1; index < this.produtos.length; index++) {
      if (this.isValid(index) || this.isProdutoRemovido(index)) {
        continue;
      }

      const element = document.getElementById(`retorno_produto_${index}`);
      if (element) {
        element.focus();
        return true;
      }
    }

    return false;
  }

  buscarProdutosApi(termoBuscaParam?: string): void {
    const termoBusca = (termoBuscaParam || this.produtoSelecionadoNome || '').trim();
    
    if (!termoBusca) {
      this.listaProdutosFiltrada = [];
      this.focusComboOnLoad = false;
      this.produtoSelecionadoCombobox = '';
      return;
    }

    if (this.ultimoTermoBuscaProdutoApi === termoBusca) {
      return;
    }

    if (this.isBuscandoProdutos) {
      this.termoBuscaProdutoPendente = termoBusca;
      return;
    }

    this.isBuscandoProdutos = true;
    this.ultimoTermoBuscaProdutoApi = termoBusca;

    const body = {
      pais: this.codigoPaisMaestro || '',
      quantidade: "10",
      produto: termoBusca
    };

    this.jsonService.findProdutoEs(body).subscribe({
      next: (resp: any[]) => {
        if (termoBusca !== this.ultimoTermoBuscaProdutoApi) {
          return;
        }

        const itemNaoEncontrado = {
          name: this.translate.instant('Produto não encontrado na pesquisa.'),
          isNotFoundItem: true
        };

        const apiProducts = resp
          .map(item => ({
            name: typeof item.produto === 'string'
              ? item.produto.replace(/'/g, '').replace(/\bnull\b/gi, '').replace(/\s+/g, ' ').trim()
              : (item.produto || ''),
            nro_presen: item.nro_presen || item.NRO_PRESEN || ''
          }))
          .filter(item => !!item.name)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        
        this.listaProdutosCompleta = [
          itemNaoEncontrado,
          ...apiProducts
        ].map((item, index) => ({ ...item, id: index }));

        this.filtrarProdutos(true);
        
        if (this.pesquisaProduto && this.pesquisaProduto.trim() !== '') {
          const termoPesquisaLower = this.pesquisaProduto.trim().toLowerCase();
          const matchExatoIndex = this.listaProdutosFiltrada.findIndex(prod => {
            const nomeProduto = (prod.name || prod.nome || '').trim().toLowerCase();
            // Exclui o item "não encontrado" da busca por correspondência exata
            return !prod.isNotFoundItem && nomeProduto === termoPesquisaLower;
          });
          if (matchExatoIndex >= 0) {
            this.produtoSelecionadoCombobox = matchExatoIndex.toString();
          }
        }

        if (this.focusComboOnLoad) {
          this.focusComboOnLoad = false;
          setTimeout(() => {
            if (this.productListRef?.nativeElement) {
              this.productListRef.nativeElement.focus();
            }
          }, 100);
        }
      },
      error: (e) => {
        this.logger.error('Erro na busca de produtos por similaridade', e);
        this.listaProdutosFiltrada = [];
        this.focusComboOnLoad = false;
        this.isBuscandoProdutos = false;
      },
      complete: () => {
        this.isBuscandoProdutos = false;
        if (this.termoBuscaProdutoPendente) {
          const proximoTermo = this.termoBuscaProdutoPendente;
          this.termoBuscaProdutoPendente = '';
          this.buscarProdutosApi(proximoTermo);
        }
      }
    });
  }

  private deveRefazerBuscaProdutoApi(termoBusca: string): boolean {
    if (!this.ultimoTermoBuscaProdutoApi || termoBusca === this.ultimoTermoBuscaProdutoApi) {
      return false;
    }

    const termoAtualLower = termoBusca.toLowerCase();
    const ultimoTermoLower = this.ultimoTermoBuscaProdutoApi.toLowerCase();
    const palavrasAtuais = termoAtualLower.split(/\s+/).filter(Boolean);
    const palavrasUltimaBusca = ultimoTermoLower.split(/\s+/).filter(Boolean);

    return palavrasAtuais.length > palavrasUltimaBusca.length && termoAtualLower.startsWith(ultimoTermoLower);
  }

  filtrarProdutos(isInitialLoad: boolean = false): void {
    if (!isInitialLoad && this.pesquisaProduto === '') {
      this.produtoSelecionadoCombobox = '';
    }

    const termoBusca = ((this.pesquisaProduto || '').trim() || this.produtoSelecionadoNome || '').trim();
    
    if (!termoBusca) {
      this.listaProdutosFiltrada = [];
      this.focusComboOnLoad = false;
      this.produtoSelecionadoCombobox = '';
      return;
    }

    const termoLower = termoBusca.toLowerCase();
    this.listaProdutosFiltrada = this.listaProdutosCompleta.filter(prod =>
      prod.isNotFoundItem || ((prod.name || prod.nome || '').toLowerCase().includes(termoLower))
    );

    const possuiProdutoNaLista = this.listaProdutosFiltrada.some(prod => !prod.isNotFoundItem);
    if (!possuiProdutoNaLista || this.deveRefazerBuscaProdutoApi(termoBusca)) {
      this.buscarProdutosApi(termoBusca);
    }
  }

  private atualizarProdutoSelecionado(produtoSelecionado: any): void {
    if (!produtoSelecionado || this.indexProdutoAtual < 0) {
      return;
    }

    const control = this.produtos.at(this.indexProdutoAtual);
    let nomeFinal: string;

    if (produtoSelecionado.isNotFoundItem) {
      // Ao selecionar não encontrado, o valor do formControl "nome" vai para o campo retorno_produto
      nomeFinal = (control.get('nome')?.value || '').trim();
    } else {
      nomeFinal = produtoSelecionado.name || produtoSelecionado.nome;
    }

    if (nomeFinal) {
      const filter = control.get('ConteudoProdFiltro')?.value || [];
      
      if (filter.length > 0 && !filter.includes(nomeFinal)) {
        control.get('ConteudoProdFiltro')?.setValue([...filter, nomeFinal]);
      }
      
      control.get('retorno_produto')?.setValue(nomeFinal);
      control.get('nro_presen')?.setValue(
        produtoSelecionado.isNotFoundItem
          ? ''
          : (produtoSelecionado.nro_presen || this.getNroPresenByNome(this.indexProdutoAtual, nomeFinal))
      );
      control.get('interaccion_del_usuario')?.setValue(
        produtoSelecionado.isNotFoundItem ? 'Item informado pelo usuário' : 'Item adicionado por pesquisa'
      );
      this.produtosValidados[this.indexProdutoAtual] = produtoSelecionado.isNotFoundItem === true;
      this.atualizarValidacao();
    }
  }

  selectProductFromList(index: number, event?: Event): void {
    if (event) event.preventDefault();
    this.produtoSelecionadoCombobox = index.toString();
    this.confirmarSelecaoCombo(event);
  }

  onListKeydown(event: KeyboardEvent): void {
    if (!this.listaProdutosFiltrada?.length) return;
    const current = parseInt(this.produtoSelecionadoCombobox || '-1', 10);
    const max = this.listaProdutosFiltrada.length - 1;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const next = current < max ? current + 1 : 0;
      this.produtoSelecionadoCombobox = next.toString();
      this.scrollListItemIntoView(next);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prev = current > 0 ? current - 1 : max;
      this.produtoSelecionadoCombobox = prev.toString();
      this.scrollListItemIntoView(prev);
    } else if (event.key === 'Enter') {
      this.confirmarSelecaoCombo(event);
    }
  }

  private scrollListItemIntoView(index: number): void {
    if (!this.productListRef) return;
    const item = this.productListRef.nativeElement.querySelector(`[data-index="${index}"]`) as HTMLElement;
    item?.scrollIntoView({ block: 'nearest' });
  }

  confirmarSelecaoCombo(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    if (this.produtoSelecionadoCombobox !== '' && this.produtoSelecionadoCombobox !== null && this.indexProdutoAtual >= 0) {
      const selectedIndex = parseInt(this.produtoSelecionadoCombobox as string, 10);
      const prod = this.listaProdutosFiltrada[selectedIndex];
      if (prod) {
        this.atualizarProdutoSelecionado(prod);
        this.fecharModalProduto(true);
      }
    }
  }

  openCombo(event: Event): void {
    if (!this.isModalProdutoOpen) {
      return;
    }
    const kbEvent = event as KeyboardEvent;
    let isArrowDown = false;
    let isShiftO = false;

    if (kbEvent && kbEvent.type === 'keydown') {
      isShiftO = kbEvent.shiftKey && (kbEvent.key === 'o' || kbEvent.key === 'O');
      isArrowDown = kbEvent.key === 'ArrowDown';

      if (!isShiftO && !isArrowDown) {
        return;
      }
    }

    if (this.productListRef?.nativeElement) {
      if (isShiftO || (isArrowDown && document.activeElement !== this.productListRef.nativeElement)) {
        event.preventDefault();
      }
      this.productListRef.nativeElement.focus();
    }
  }

  isProdutoRemovido(index: number): boolean {
    const motivo = this.produtos.at(index).get('motivo_exclusao_produto')?.value;
    return !!motivo;
  }

  fecharModalRemover(): void {
    this.isModalRemoverOpen = false;
    this.indexProdutoRemover = -1;
    this.motivoRemocaoSelecionado = '';
    this.produtoRemoverNome = '';
  }

  onMotivoRemocaoSelecionado(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const motivo = target.value;
    if (motivo && this.indexProdutoRemover >= 0) {
      this.produtos.at(this.indexProdutoRemover).get('motivo_exclusao_produto')?.setValue(motivo);
      this.atualizarValidacao();
    }
    this.fecharModalRemover();
  }

  desfazerExclusao(index: number): void {
    this.produtos.at(index).get('motivo_exclusao_produto')?.setValue('');
    this.atualizarValidacao();
  }

  podeDesfazer(): boolean {
    const status = this.prescriptionItem?.status;
    return status === 'P' || status === 'p' || !status;
  }

  isProdutoManual(index: number): boolean {
    return this.produtos.at(index).get('is_manual')?.value === true;
  }

  fecharModalConfirmarExclusaoManual(): void {
    this.isModalConfirmarExclusaoManualOpen = false;
    this.indexProdutoManualRemover = -1;
  }

  confirmarExclusaoManual(): void {
    if (this.indexProdutoManualRemover >= 0) {
      this.produtos.removeAt(this.indexProdutoManualRemover);
      this.produtosValidados.splice(this.indexProdutoManualRemover, 1);
      this.setupProdutoFilters();
      this.atualizarValidacao();
    }
    this.fecharModalConfirmarExclusaoManual();
  }
}
